import { IFormKey } from 'src/app/modules/shared/models/forms';
import { Validators } from "@angular/forms"
import moment = require('moment');
import { IPersonIntesa } from 'src/app/modules/shared/models/policy.model';
import { IPersonDataIsv } from '../beneficiary-change-isv/beneficiary-change-isv.constants';

export const claim_notification_template = {
    nome: { value: null, disable: true },
    cognome: { value: null, disable: true },
    codiceFiscale: { value: null, disable: true },
    dataNascita: { value: null, disable: true },
    dataDecesso: null
}

export const claim_notification_validators = {
    nome: null,
    cognome: null,
    codiceFiscale: null,
    dataNascita: null,
    dataDecesso: [Validators.required]
}

export const claim_notification_form_keys: IFormKey[] = [
    {
        id: 'nome-assicurato-field',
        controlName: 'nome',
        label: 'Nome',
        css: 'col-4'
    },
    {
        id: 'cognome-assicurato-field',
        controlName: 'cognome',
        label: 'Cognome',
        css: 'col-4'
    },
    {
        id: 'codiceFiscale-assicurato-field',
        controlName: 'codiceFiscale',
        label: 'Codice fiscale',
        css: 'col-4'
    },
    {
        id: 'dataNascita-assicurato-field',
        controlName: 'dataNascita',
        label: 'Data di nascita',
        css: 'col-4',
        type: 'DATEPICKER'
    },
    {
        id: 'dataDecesso-assicurato-field',
        controlName: 'dataDecesso',
        label: 'Data decesso assicurato',
        css: 'col-4',
        type: 'DATEPICKER',
        maxDate: moment()
    },
]

export const declarant_claim_notification_template = {
    naturaGiuridica: null
}

export const declarant_claim_notification_validators = {
    naturaGiuridica: [Validators.required]
}

export const declarant_claim_notification_PF_validators = {
    naturaGiuridica: [Validators.required],
    nome: [Validators.required],
    cognome: [Validators.required],
    codiceFiscale: [Validators.required]
}
export const declarant_claim_notification_PG_validators = {
    naturaGiuridica: [Validators.required],
    ragioneSociale: [Validators.required],
    partitaIva: [Validators.required]
}

export const declarant_claim_notification_form_keys: IFormKey[] = [
    {
        id: 'naturaGiuridica-dichiarante-field',
        controlName: 'naturaGiuridica',
        label: 'Natura giuridica',
        type: 'SELECT',
        css: 'col-4',
        options: [
            { key: 'personaFisica', value: 'Persona fisica' },
            { key: 'personaGiuridica', value: 'Persona giuridica' }
        ]
    },
    {
        id: 'assicurato-new-line-field',
        label: null,
        controlName: null,
        type: 'NEW_LINE',
        css: 'col-12'
    },
    {
        id: 'nome-assicurato-field',
        controlName: 'nome',
        label: 'Nome',
        css: 'col-4',
        hidden: true
    },
    {
        id: 'cognome-assicurato-field',
        controlName: 'cognome',
        label: 'Cognome',
        css: 'col-4',
        hidden: true
    },
    {
        id: 'codiceFiscale-assicurato-field',
        controlName: 'codiceFiscale',
        label: 'Codice fiscale',
        css: 'col-4',
        hidden: true
    },
    {
        id: 'ragioneSociale-assicurato-field',
        controlName: 'ragioneSociale',
        label: 'Ragione sociale',
        css: 'col-4',
        hidden: true
    },
    {
        id: 'partitaIva-assicurato-field',
        controlName: 'partitaIva',
        label: 'Partita IVA',
        css: 'col-4',
        hidden: true
    }
]

export const declarant_claim_notification_persona_fisica_controls: string[] = [
    'nome', 
    'cognome', 
    'codiceFiscale'
];

export const declarant_claim_notification_persona_giuridica_controls: string[] = [
    'ragioneSociale', 
    'partitaIva'
];

export interface IComunicazioneSinistroRequest {
    policyNumber: string;
    policyInsured: IPersonDataIsv;
    policyHolder: IPersonDataIsv;
    declarant: IPersonDataIsv;
    dateOfDeath: string;
}